import { TableCell } from './Table';
import React, { CSSProperties, memo } from 'react';
import PropTypes from 'prop-types';

export type TableColumnProps = {
  item: any;
  accessor: (row: any) => JSX.Element | '' | undefined;
  width: number | string | undefined;
  className?: string;
  style?: CSSProperties;
};

const TableColumn: React.FC<TableColumnProps> = memo(
  ({ accessor, item, width, className, style }) => {
    let value: any = undefined;
    try {
      value = accessor(item);
    } catch (e) {
      console.error('Error accessing column value', item, e);
    }
    return (
      <TableCell
        className={className}
        title={typeof value === 'string' ? value : undefined}
        role="cell"
        style={{ ...style, width }}
      >
        {value}
      </TableCell>
    );
  }
);

TableColumn.displayName = 'TableColumn';

TableColumn.propTypes = {
  accessor: PropTypes.any.isRequired,
  item: PropTypes.any.isRequired,
  width: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default TableColumn;
